//
// Module for the MemberDirect FAQ edit view
//
rs.module("content/system/configuration/faqs/edit",

    [
        "common/select-helper"
    ],

    function (selectHelper) {
        // initialize the module
        function initialize(jsSelectors) {
            var form = $.js(jsSelectors.form);
            var displayFlagSelector = form.js(jsSelectors.displayFlagSelector);
            var fundSelector = form.js(jsSelectors.fundSelector);
            var fundSelectHelper = selectHelper.getHelper(fundSelector);

            displayFlagSelector.change(function displayFlagsChanged() {
                if (displayFlagSelector.val().includes("Post") && !displayFlagSelector.val().includes("Pre")) {
                    fundSelectHelper.setDisabled(false);
                } else {
                    fundSelectHelper.setValue(null);
                    fundSelectHelper.setDisabled(true);
                }
            });
        }
        
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);